import React from 'react';
import { Box, Text } from '@wix/design-system';
import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { CoreDomainSearchModule } from '../../module';
import { ExperimentSpecs } from '../../constants';
export const TLDTooltipContent = _ref => {
  var _getPremiumEssentials;
  let {
    tld,
    isVoucherSupported
  } = _ref;
  const {
    t,
    Trans
  } = CoreDomainSearchModule.internals.useTranslations();
  const isMatchCycle = !!((_getPremiumEssentials = getPremiumEssentialsSafe()) != null && (_getPremiumEssentials = _getPremiumEssentials.experiments) != null && _getPremiumEssentials[ExperimentSpecs.MatchDomainCycleToPremiumCycle]);
  return /*#__PURE__*/React.createElement(Box, {
    padding: "SP3 SP4",
    gap: "SP6",
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Text, {
    light: true,
    size: "tiny",
    weight: "bold"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: `core_domain_search.search_bar.tld_promotions.tooltip.${tld}`,
    components: [/*#__PURE__*/React.createElement("b", null)]
  })), isVoucherSupported && /*#__PURE__*/React.createElement(Text, {
    light: true,
    size: "tiny",
    weight: "bold"
  }, t(isMatchCycle ? 'core_domain_search.search_bar.tld_promotions.tooltip.free_with_premium.match_cycle' : 'core_domain_search.search_bar.tld_promotions.tooltip.free_with_premium')));
};
//# sourceMappingURL=TLDTooltipContent.js.map